import Business from '@constants/Business'
import coverPhoto from '@utils/links/coverPhoto'

export default function offerSchemaImage (buy, offer) {
    return buy
        ? Business.host + '/assets/icons/large-samochody-fb.jpeg'
        : coverPhoto(offer.tracking.pid)
}